import apiService from './api';

class NotificationService {
  async list({ limit = 30, before } = {}) {
    const params = new URLSearchParams();
    if (limit) params.set('limit', String(limit));
    if (before) params.set('before', before);
    const qs = params.toString();
    return apiService.get(`/api/user/notifications${qs ? `?${qs}` : ''}`, { useCache: false });
  }

  async markRead(notificationId) {
    return apiService.patch(`/api/user/notifications/${notificationId}/read`, {}, { useCache: false });
  }

  async markAllRead() {
    return apiService.post('/api/user/notifications/read-all', {}, { useCache: false });
  }
}

export const notificationService = new NotificationService();
export default notificationService;
